import React from 'react';

import { ProductType } from 'constants/product';

//
// --- Types ---

interface LayoutSwitchProps {
  /** children should be `ProductMatch` components, or have a `product` prop */
  children: React.ReactElement[];
  /** current product type the app is set to; determines which children to display */
  currentProduct: ProductType;
  /** boolean of whether this is for the discovery version of the app or not */
  isDiscovery: boolean;
}

//
// --- LayoutSwitch Component ---

/**
 * Render different children based on current product. Use `ProductMatch` components
 * for children.
 */
const LayoutSwitch: React.FC<LayoutSwitchProps> = props => {
  const { currentProduct, children, isDiscovery } = props;

  const matchedChild = children.find(child => {
    const childIsDiscovery = child?.props?.isDiscovery;
    const matchingDiscovery = isDiscovery === childIsDiscovery;
    const productToMatch = child?.props?.product;

    return productToMatch
      ? Array.isArray(productToMatch)
        ? productToMatch.includes(currentProduct) && matchingDiscovery
        : child.props.product === currentProduct && matchingDiscovery
      : false;
  });

  return matchedChild || null;
};

export default LayoutSwitch;
